import React, { } from 'react';
import EventBlock from '../../components/EventBlock'
import PageLayout from '../../components/PageLayout';



export default function FederationadministratorEventsCalendar(props) {
    // const ctx = React.useMemo(() => ({
    //     mix: () => {
    //         return {
    //             organizatorFederatsiyaID: 1, // Организатор федерация
    //         }
    //     }
    // }), [])

    return (
        <PageLayout>
            <EventBlock source={"/api/meropriyatiya/list/fed"}
                base="federation-administrator"
                sourceKey="fed"
                create={true}
                // context={ctx}
                ctx={{organizatorFederatsiyaID: 1}}
            />
        </PageLayout>
    );
}
